// extracted by mini-css-extract-plugin
module.exports = {"rssStyle":"RssDirective_rssStyle__l2Ubx","muted":"RssDirective_muted__JIfOX"};